//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('batchDelPurchLinesBs', {
//        templateUrl: 'views/components/views/batchDelPurchLinesBs/batchDelPurchLinesBs.template.html?v=' + module.version,
//		controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'batchDelPurchLinesBsService', function ($stateParams, stateService, batchDelPurchLinesBsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let batchDelPurchLineKeyno = $stateParams.batchdelpurchline_keyno;
//            let batchDeliveryKeyno = $stateParams.batchdelivery_keyno;

//            vm.model = {
//                bgBatchPurchaseLinesBs: {
//                    selected: '0',
//                    buttons: [
//                        { id: '0', label: 'batchdelivery_gb_simple', color: 'primary', onClick: () => vm.model.bgBatchPurchaseLinesBs.selected = '0' },
//                        { id: '1', label: 'batchdelivery_gb_details', color: 'primary', onClick: () => vm.model.bgBatchPurchaseLinesBs.selected = '1' }
//                    ]
//                },
//                setting: {},
//                inputListBatchPurchaseLines: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await batchDelPurchLinesBsService.getSetting({ batchdelivery_keyno: batchDeliveryKeyno }))[0];
//            }

//            async function loadBatchPurchaseLines() {
//                vm.model.inputListBatchPurchaseLines = await batchDelPurchLinesBsService.listBatchPurchaseLines({
//                    batchdelpurchline_keyno: batchDelPurchLineKeyno,
//                    batchdelivery_keyno: batchDeliveryKeyno
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON RADIO FUNCTIONS

//            vm.selectBgBatchPurchaseLinesBs = function (value) {
//                vm.model.bgBatchPurchaseLinesBs.selected = value;
//            }

//            // #endregion BUTTON RADIO FUNCTIONS

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                batchDelPurchLinesBsService.saveObj({ records: vm.model.inputListBatchPurchaseLines }).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadSetting();
//                loadBatchPurchaseLines();
//            }

//            // #endregion ON INIT FUNCTION

//		}]
//	});
//})();
